<p class="body--s text-grey">
  {{ 'checkout.digitalNativeCheckout.paymentType.invoice.info' | cxTranslate }}
</p>
<dcp-billing-information
  [invoiceContacts]="invoiceContacts"
  [invoiceAddresses]="invoiceAddresses">
</dcp-billing-information>
